// src/utils/formatters.js

// Formatar CPF: 12345678900 → 123.456.789-00
export const formatCPF = (cpf) => {
  // Verificações de valores inválidos
  if (cpf === null || cpf === undefined || cpf === '' || cpf === 'undefined' || cpf === 'null' || cpf === 'NaN') {
    return '-';
  }
  
  // Converte para string se for número
  const cpfStr = String(cpf).trim();
  
  // Verifica se é um valor vazio após conversão
  if (!cpfStr || cpfStr === 'null' || cpfStr === 'undefined' || cpfStr === 'NaN') {
    return '-';
  }
  
  // Remove tudo que não é número
  const cleaned = cpfStr.replace(/\D/g, '');
  
  // Verifica se tem conteúdo após limpeza
  if (!cleaned || cleaned.length === 0) return '-';
  
  // Aplica a máscara
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  
  return cpfStr; // Retorna original se não tiver 11 dígitos
};

// Formatar Telefone: 5561999999999 → +55 (61) 99999-9999
export const formatPhoneNumber = (phone) => {
  if (!phone) return '-';
  
  // Remove tudo que não é número
  const cleaned = phone.replace(/\D/g, '');
  
  // Formato internacional com DDD
  if (cleaned.startsWith('55') && cleaned.length === 13) {
    // 5561999999999 → +55 (61) 99999-9999
    return cleaned.replace(/^55(\d{2})(\d{5})(\d{4})$/, '+55 ($1) $2-$3');
  } else if (cleaned.startsWith('55') && cleaned.length === 12) {
    // 556199999999 → +55 (61) 9999-9999
    return cleaned.replace(/^55(\d{2})(\d{4})(\d{4})$/, '+55 ($1) $2-$3');
  } else if (cleaned.length === 11) {
    // 61999999999 → +55 (61) 99999-9999
    return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, '+55 ($1) $2-$3');
  } else if (cleaned.length === 10) {
    // 6199999999 → +55 (61) 9999-9999
    return cleaned.replace(/^(\d{2})(\d{4})(\d{4})$/, '+55 ($1) $2-$3');
  }
  
  return phone; // Retorna original se não corresponder aos formatos
};
